import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import type { AdminLiveEventRow } from "@tih/shared";
import { adminFetchLive } from "../../api/client";

type Target = "stream" | "attendees" | "gallery" | "events";

function pickOngoingEventId(events: AdminLiveEventRow[]): number | null {
  const ongoing = events.find((e) => e.phase === "ongoing");
  if (ongoing) return ongoing.id;
  const upcoming = events
    .filter((e) => e.phase === "upcoming")
    .sort((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt))[0];
  return upcoming?.id ?? null;
}

export function AdminEventLegacyRedirect({ target }: { target: Target }) {
  const [to, setTo] = useState<string | null>(null);

  useEffect(() => {
    if (target === "events") {
      setTo("/admin/events");
      return;
    }
    adminFetchLive()
      .then((res) => {
        const id = pickOngoingEventId(res.events);
        if (id == null) {
          setTo("/admin/events");
          return;
        }
        const tab =
          target === "stream"
            ? "stream"
            : target === "attendees"
              ? "attendees"
              : "gallery";
        setTo(`/admin/events/${id}/${tab}`);
      })
      .catch(() => setTo("/admin/events"));
  }, [target]);

  if (!to) return <div className="admin-page" style={{ opacity: 0.5 }}>Redirecting…</div>;
  return <Navigate to={to} replace />;
}
